import { render } from "./addPointsPerson.vue?vue&type=template&id=2f147083&scoped=true"
import script from "./addPointsPerson.vue?vue&type=script&lang=js"
export * from "./addPointsPerson.vue?vue&type=script&lang=js"

import "./addPointsPerson.vue?vue&type=style&index=0&id=2f147083&lang=scss"
import "./addPointsPerson.vue?vue&type=style&index=1&id=2f147083&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f147083"],['__file',"src/views/marketing/components/addPointsPerson.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f147083"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f147083', __exports__)) {
    console.log('reload')
    api.reload('2f147083', __exports__)
  }
  
  module.hot.accept("./addPointsPerson.vue?vue&type=template&id=2f147083&scoped=true", () => {
    console.log('re-render')
    api.rerender('2f147083', render)
  })

}


export default __exports__